export class Param {
  public id?: string;
  public param_group: string;
  public description: string;
  public param_order?: number;
  public param_code?: string;
  public param_functional_code?: string;
  public division_id?: number;
  public param_key?: string;
}
export class ParamFunctionalCode {
  description: string;
  functional_code: string;
  name: string;
}




// WEBPACK FOOTER //
// ./src/app/models/loyalty-param.model.ts